import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: "XS" | "S" | "M" | "L" | "XL" | "XXL";
  color?: string;
  style?: object;
};

interface SizeData {
    size: number;
    stroke: number;
  }

  interface AvailableSizes {
    XS: SizeData;
    S: SizeData;
    M: SizeData;
    L: SizeData;
    XL: SizeData;
    XXL: SizeData;
  }
  ;
const availableSizes: AvailableSizes = {"XS":{"size":16,"stroke":1.3},"S":{"size":20,"stroke":1.5},"M":{"size":24,"stroke":1.8},"L":{"size":40,"stroke":2.2},"XL":{"size":48,"stroke":2.5},"XXL":{"size":70,"stroke":2.8}};
function Clock({
  size = "M",
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  const strokeWidth = availableSizes[size]?.stroke;
  const appliedSize = availableSizes[size]?.size;
  return <Svg width={appliedSize} height={appliedSize} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color={color} style={style}><path vectorEffect="non-scaling-stroke" d="M16.0598 12.12H11.4098V6.52001M12.0098 2.51001C10.8279 2.51001 9.65755 2.7428 8.56562 3.19509C7.47368 3.64739 6.48153 4.31032 5.6458 5.14605C4.81008 5.98178 4.14714 6.97393 3.69485 8.06586C3.24256 9.15779 3.00977 10.3281 3.00977 11.51C3.00977 12.6919 3.24256 13.8622 3.69485 14.9542C4.14714 16.0461 4.81008 17.0382 5.6458 17.874C6.48153 18.7097 7.47368 19.3726 8.56562 19.8249C9.65755 20.2772 10.8279 20.51 12.0098 20.51C14.3967 20.51 16.6859 19.5618 18.3737 17.874C20.0616 16.1861 21.0098 13.897 21.0098 11.51C21.0098 9.12306 20.0616 6.83388 18.3737 5.14605C16.6859 3.45822 14.3967 2.51001 12.0098 2.51001Z" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" /></Svg>;
}
export default Clock;